// Traduction des textes du catalogue (classes, familles, modifications, boutique, pass, missions).
// Le français est la source (données du dossier) ; chaque autre langue fournit une table par identifiant.
// Sans entrée traduite, le texte français est affiché (repli visible, jamais de clé brute).

export interface CatalogDict {
  /** Identifiant de classe → [nom, description]. */
  classes: Record<string, readonly [string, string]>;
  /** Nom français de famille → nom traduit. */
  families: Record<string, string>;
  /** Identifiant de modification → [nom, description]. */
  mods: Record<string, readonly [string, string]>;
  /** Nom français de groupe de modifications → nom traduit. */
  groups: Record<string, string>;
  /** Type de tube (compatibilité des modifications) → libellé. */
  needs: Record<string, string>;
  /** Identifiant d'article de boutique (cosmétique, pack de gemmes) → nom. */
  shop: Record<string, string>;
  /** Identifiant d'objet du pass → libellé. */
  passItems: Record<string, string>;
  /** Identifiant de mission → libellé. */
  missions: Record<string, string>;
  /** Identifiant de saison → nom. */
  seasons: Record<string, string>;
}

/** Libellés français des types de tubes (source). */
export const FR_NEEDS: Record<string, string> = {
  bullet: 'balles',
  shell: 'obus',
  missile: 'missiles',
  beam: 'lasers',
  orb: 'orbes',
  drone: 'drones',
  trap: 'pièges',
  mine: 'mines',
  explosive: 'explosifs',
  heat: 'chauffe',
  multi: 'multi-tubes',
  collision: 'collision',
  auto: 'tourelles auto',
  unit: 'unités',
  charge: 'tir chargé',
  gun: 'tir cyclique',
};

let cat: CatalogDict | null = null;

export function setCatalog(c: CatalogDict | null): void {
  cat = c;
}

export const className = (c: { id: string; name: string }): string => cat?.classes[c.id]?.[0] ?? c.name;
export const classDesc = (c: { id: string; desc: string }): string => cat?.classes[c.id]?.[1] ?? c.desc;
export const familyName = (family: string): string => cat?.families[family] ?? family;
export const modName = (d: { id: string; name: string }): string => cat?.mods[d.id]?.[0] ?? d.name;
export const modDesc = (d: { id: string; desc: string }): string => cat?.mods[d.id]?.[1] ?? d.desc;
export const groupName = (group: string): string => cat?.groups[group] ?? group;
export const needLabel = (need: string): string => cat?.needs[need] ?? FR_NEEDS[need] ?? need;
export const shopName = (item: { id: string; name: string }): string => cat?.shop[item.id] ?? item.name;
export const passItemLabel = (item: string, fallback: string): string => cat?.passItems[item] ?? fallback;
export const missionLabel = (id: string, fallback: string): string => cat?.missions[id] ?? fallback;
export const seasonName = (id: string, fallback: string): string => cat?.seasons[id] ?? fallback;
